import React__default from 'react';
import PropTypes__default from 'prop-types';
import { useBreakpoints } from '../../hooks/useBreakpoints.js';
import { makeStyles, useTheme, Box, Typography, Grid } from '@material-ui/core';
import CustomRichTextFromMarkdown from '../../widgets/text/CustomRichTextFromMarkdown.js';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { retrieveContentfulImage } from '../../common/image.js';

var useStyles = makeStyles(function (theme) {
  return {
    centerContainerMobile: {
      paddingLeft: 0,
      paddingRight: 0
    },
    iconItem: {
      width: theme.spacing(12.5),
      height: theme.spacing(12.5)
    },
    itemDescription: {
      fontWeight: 400
    },
    mt4: {
      marginTop: theme.spacing(4),
      paddingBottom: theme.spacing(12)
    },
    ma: {
      margin: "auto"
    },
    gridItem: {
      height: "100%"
    }
  };
});
var ColumnsFramedBox = function ColumnsFramedBox(_ref) {
  var title = _ref.title,
    numOfColumns = _ref.numOfColumns,
    columnItems = _ref.columnItems,
    bgColor = _ref.bgColor;
  var theme = useTheme();
  var classes = useStyles();
  var _useBreakpoints = useBreakpoints(),
    isExtraSmallScreen = _useBreakpoints.isExtraSmallScreen;
  return /*#__PURE__*/React__default.createElement(Box, {
    bgcolor: bgColor,
    mx: "auto",
    py: 11
  }, /*#__PURE__*/React__default.createElement(Box, {
    maxWidth: theme.breakpoints.width("lg"),
    mx: "auto",
    px: isExtraSmallScreen() ? 2 : 10,
    bgcolor: theme.palette.background["default"],
    borderRadius: 8
  }, title && /*#__PURE__*/React__default.createElement(Box, {
    pt: isExtraSmallScreen() ? 5.625 : 7.5,
    textAlign: "center"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h4",
    component: "h2"
  }, title)), /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 4,
    className: classes.mt4
  }, columnItems && columnItems.map(function (item, index) {
    return /*#__PURE__*/React__default.createElement(Grid, {
      key: index,
      item: true,
      xs: 12,
      sm: 6,
      md: 12 / numOfColumns,
      lg: 12 / numOfColumns,
      container: true,
      direction: isExtraSmallScreen() ? "row" : "column",
      wrap: isExtraSmallScreen() ? "wrap" : "nowrap",
      alignItems: "center",
      className: classes.gridItem
    }, /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      xs: 4,
      sm: 12
    }, (item === null || item === void 0 ? void 0 : item.imageUrl) && /*#__PURE__*/React__default.createElement(LazyLoadImage, {
      className: classes.iconItem,
      src: retrieveContentfulImage(item.imageUrl, {
        width: 200,
        height: 200
      }),
      alt: (item === null || item === void 0 ? void 0 : item.imageTitle) || ""
    })), /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      xs: 8,
      sm: 12
    }, (item === null || item === void 0 ? void 0 : item.title) && /*#__PURE__*/React__default.createElement(Box, {
      mt: 1,
      ml: isExtraSmallScreen() ? 1 : 0
    }, /*#__PURE__*/React__default.createElement(Typography, {
      variant: "h6",
      component: "h3",
      align: isExtraSmallScreen() ? "left" : "center"
    }, item === null || item === void 0 ? void 0 : item.title))), /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 12
    }, (item === null || item === void 0 ? void 0 : item.description) && /*#__PURE__*/React__default.createElement(Box, {
      mt: 1.5,
      textAlign: "center"
    }, /*#__PURE__*/React__default.createElement(CustomRichTextFromMarkdown, {
      markdownString: item === null || item === void 0 ? void 0 : item.description
    }))));
  }))));
};
ColumnsFramedBox.defaultProps = {
  bgColor: "background.default",
  numOfColumns: 3
};
ColumnsFramedBox.propTypes = {
  title: PropTypes__default.string,
  numOfColumns: PropTypes__default.oneOf([1, 2, 3, 4, 6, 12]),
  columnItems: PropTypes__default.array,
  bgColor: PropTypes__default.string
};

export { ColumnsFramedBox as default };
//# sourceMappingURL=ColumnsFramedBox.js.map
